module.exports = __webpack_public_path__ + "img/icecream.b8b91b9e.jpg";